var map = {
	"./aop.webp": "d088",
	"./bbc.webp": "9399",
	"./bio.webp": "6b99",
	"./fm.svg": "b446",
	"./igp.webp": "2120",
	"./lbr.webp": "35bc",
	"./msc.svg": "b66c",
	"./pof.webp": "da8a",
	"./sge.svg": "d73d",
	"./vbf.webp": "dfa7",
	"./vof.svg": "34cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3db";